"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetChain = void 0;
const defineChain_js_1 = require("../../utils/chain/defineChain.js");
exports.assetChain = (0, defineChain_js_1.defineChain)({
    id: 42_420,
    name: 'AssetChain Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Real World Asset',
        symbol: 'RWA',
    },
    rpcUrls: {
        default: { http: ['https://mainnet-rpc.assetchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Asset Chain Explorer',
            url: 'https://scan.assetchain.org',
            apiUrl: 'https://scan.assetchain.org/api',
        },
    },
    testnet: false,
    contracts: {},
});
//# sourceMappingURL=assetChain.js.map